import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { errorNotification } from "../../../../../redux/notifications";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import ProgressBar from "react-bootstrap/ProgressBar";
import PulseLoader from "react-spinners/PulseLoader";
import Button from "react-bootstrap/Button";
import CloseButton from "react-bootstrap/CloseButton";
import PropTypes from "prop-types";
import "./FileUploader.scss";

const getExtension = (fileName) => {
    return fileName.toLowerCase().substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
}

const FileUploader = ({disabled,isRedirecting,onFileSelectSuccess, onFileSelectError}) => {
    const [uploadInputFileName, setUploadInputFileName] = useState("FileName.docx");
    const [isLoadingFile, setIsLoadingFile] = useState(false);
    const [isRedirectingInternalFlag, setIsRedirectingInternalFlag] = useState(false);
    const [countOfProgess, setCountOfProgess] = useState(0);
    const [multiplierOfProgess, setMultiplierOfProgess] = useState(0);
    const fileInput = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isLoadingFile === true || isRedirecting === true) {
            const timer = setInterval( async () => {
                setCountOfProgess((oldProgress) => {
                    if (100 == oldProgress) return;
                    return Math.min(oldProgress + 4 + Math.random() * multiplierOfProgess, 100);
                });
            }, 499);

            return () => {
                clearInterval(timer);
            };
        }
    }, [isLoadingFile, isRedirecting]);

    useEffect(() => {
        if (countOfProgess == 100) {
            setIsLoadingFile(false);
            setIsRedirectingInternalFlag(false);
        }
    }, [countOfProgess]);

    const handleFileSelected = async (e) => {
        const file = e.target.files[0];
        const sizeMB = file?.size / 1048576.0; //1 MB = 1,048,576.0 B
        if (sizeMB < 5)  {
            setCountOfProgess(35);
            setMultiplierOfProgess(20);
        } else if (sizeMB < 15 * 1048576)  {
            setCountOfProgess(20);
            setMultiplierOfProgess(15);
        } else if (sizeMB < 50)  {
            setCountOfProgess(10);
            setMultiplierOfProgess(10);
        } else if (sizeMB < 100)  {
            setCountOfProgess(5);
            setMultiplierOfProgess(5);
        } else {
            setCountOfProgess(1);
            setMultiplierOfProgess(1);
        }

        if (sizeMB> 150) {
            dispatch(errorNotification({
                header: "File size error",
                message: "The Task file size cannot exceed the limit of 150MB",
            }));
            onFileSelectError({ error: "The Task file size cannot exceed the limit of 150MB" });
        } else if (file.type.includes("officedocument.spreadsheetml.sheet") || getExtension(file.name) == "xlsx") {
            setIsLoadingFile(true);
            setIsRedirectingInternalFlag(true)
            setUploadInputFileName(file.name);
            onFileSelectSuccess(file);
        } else {
            setIsLoadingFile(true);
            setIsRedirectingInternalFlag(false)
            setUploadInputFileName(file.name);
            onFileSelectSuccess(file);
        }
    }

    const handleStartWithNewFile= async (e) => {
        if (!disabled && fileInput.current) {
            fileInput.current.click();
        } else {
            dispatch(errorNotification({
                header: "No Project Selected",
                message: "You must select a project first, to add a new file",
            }));
        }
    }

    return (
        <Row>
            <Col style={{ margin: "0px", padding: "0px" }}>
                { !isLoadingFile  && !isRedirecting &&
                    <Row style={{  margin: "0px", padding: "0px" }}>
                        <Form.Group  style={{display: "none" }} className="new-file-button" as={Row}>
                            <Form.File  ref={fileInput} type="file"  label="Start with a new file" onChange={(e) => handleFileSelected(e)} />
                        </Form.Group>
                        <Button className="new-file-button" type="file" onClick={e => handleStartWithNewFile()}>
                            Start with a new file
                        </Button>
                    </Row>
                }
                { !isRedirecting && (isLoadingFile  && !isRedirectingInternalFlag) &&
                    <React.Fragment>
                        <Row style={{  margin: "0px 0px 16px 0px", padding: "0px" }}>
                            <div className="uploading-message-container">
                                <p className="uploading-message">
                                    Uploading...
                                </p>
                            </div>
                        </Row>
                        <Row className="progress-bar-container">
                            <Col xs="11" style={{ margin: "0px", padding: "0px"}} >
                                <p className="progress-bar-label">{uploadInputFileName}</p>
                                <ProgressBar className="progress-bar-counter" now={countOfProgess} />
                            </Col>
                            <Col xs="1" style={{ margin: "0px", padding: "0px"}} >
                                <Row style={{margin: "0px", padding: "0px"}}>
                                    <CloseButton className="close-upload-file" onClick={() => setIsLoadingFile(false)} />
                                </Row>
                            </Col>
                        </Row>
                    </React.Fragment>
                }
                { (isRedirecting || (isLoadingFile && isRedirectingInternalFlag)) &&
                    <React.Fragment>
                        <Row style={{  margin: "0px 0px 16px 0px", padding: "0px" }}>
                            <div className="uploading-message-container">
                                <p className="uploading-message">
                                    Redirecting...
                                </p>
                            </div>
                        </Row>
                        <Row className="progress-bar-container">
                            <Col xs="11" style={{ margin: "0px", padding: "0px"}} >
                                <div className="loading-spinner-wrapper">
                                    <PulseLoader className="loading-spinner"></PulseLoader>
                                </div>
                            </Col>
                        </Row>
                    </React.Fragment>
                }
            </Col>
        </Row>
    )
}

FileUploader.propTypes = {
    disabled: PropTypes.bool.isRequired,
    isRedirecting: PropTypes.bool.isRequired,
    onFileSelectSuccess: PropTypes.func.isRequired,
    onFileSelectError: PropTypes.func.isRequired
}

export default FileUploader;